import React from "react";
import { Link } from "react-router-dom";
import {
  Instagram,
  MapPin,
  Phone,
  // Mail,
  Clock,
} from "lucide-react";
import WhatsappLogo from "../assets/whatsapp-logo.png";

const Footer = () => {
  return (
    <footer className="bg-domigo-dark text-white relative overflow-hidden footer-polished">
      {/* Top Border with gradient */}
      <div className="h-1 bg-gradient-to-r from-domigo-purple via-domigo-purple to-domigo-blue"></div>

      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-domigo-pink/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-64 h-64 bg-domigo-purple/5 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center mb-5">
              <div className="w-12 h-12 bg-gradient-pink rounded-2xl flex items-center justify-center mr-3 shadow-pink">
                <span className="text-white font-bold text-2xl">D</span>
              </div>
              <div>
                <div className="text-xl font-bold">Domigo</div>
                <div className="text-sm text-gray-300 font-medium">
                  Premium Pet Care
                </div>
              </div>
            </div>
            <p className="text-gray-300 mb-7 leading-relaxed text-[15px]">
              Premium pet grooming, daycare, and boarding services in Austin,
              TX. Loving care for your furry family members since 2015.
            </p>

            {/* Social Media */}
            <div className="flex flex-wrap gap-3">
              <a
                href="https://www.instagram.com/domigoindia?igsh=MWswcnE0bTk1dWw3&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-gray-300 hover:bg-gradient-pink hover:text-white transition-all duration-300 transform hover:-translate-y-0.5"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://wa.me/918319510854"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Chat on WhatsApp"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-gray-300 hover:bg-gradient-pink hover:text-white transition-all duration-300 transform hover:-translate-y-0.5"
              >
                <img src={WhatsappLogo} alt="WhatsApp" className="w-5 h-5 filter brightness-0 invert" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white tracking-[0.01em]">Services</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/services"
                  className="text-gray-300 hover:text-domigo-pink transition-colors hover:translate-x-1 inline-block duration-200"
                >
                  Grooming
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-gray-300 hover:text-domigo-pink transition-colors hover:translate-x-1 inline-block duration-200"
                >
                  Daycare
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-gray-300 hover:text-domigo-pink transition-colors hover:translate-x-1 inline-block duration-200"
                >
                  Boarding
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-gray-300 hover:text-domigo-pink transition-colors hover:translate-x-1 inline-block duration-200"
                >
                  Pricing
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white tracking-[0.01em]">Company</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-gray-300 hover:text-domigo-pink transition-colors hover:translate-x-1 inline-block duration-200"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/gallery"
                  className="text-gray-300 hover:text-domigo-pink transition-colors hover:translate-x-1 inline-block duration-200"
                >
                  Gallery
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-300 hover:text-domigo-pink transition-colors hover:translate-x-1 inline-block duration-200"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white tracking-[0.01em]">Support</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/faq"
                  className="text-gray-300 hover:text-domigo-pink transition-colors hover:translate-x-1 inline-block duration-200"
                >
                  FAQs
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-gray-300 hover:text-domigo-pink transition-colors hover:translate-x-1 inline-block duration-200"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/vaccination-policy"
                  className="text-gray-300 hover:text-domigo-pink transition-colors hover:translate-x-1 inline-block duration-200"
                >
                  Vaccination Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/cancellation-policy"
                  className="text-gray-300 hover:text-domigo-pink transition-colors hover:translate-x-1 inline-block duration-200"
                >
                  Cancellation & Refund Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms-of-service"
                  className="text-gray-300 hover:text-domigo-pink transition-colors hover:translate-x-1 inline-block duration-200"
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700/90 mt-12 pt-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Hours */}
            <div>
              <h4 className="font-semibold mb-3 flex items-center tracking-[0.02em]">
                <Clock className="mr-2" size={18} />
                HOURS
              </h4>
              <div className="text-gray-300 space-y-1 text-sm">
                <p>Mon-Sat 9:30 am–7:30 pm</p>
                <p>Sun 10:00 am–7:30 pm</p>
              </div>
            </div>

            {/* Contact */}
            <div>
              <h4 className="font-semibold mb-3 flex items-center tracking-[0.02em]">
                <Phone className="mr-2" size={18} />
                CONTACT
              </h4>
              <div className="text-gray-300 space-y-1 text-sm">
                {/* <p className="flex items-center">
                  <Mail className="mr-2" size={14} />
                  hello@domigo.com
                </p> */}
                <p className="flex items-center">
                  <Phone className="mr-2" size={14} />
                  +91 831 951 0854
                </p>
              </div>
            </div>

            {/* Location */}
            <div>
              <h4 className="font-semibold mb-3 flex items-center tracking-[0.02em]">
                <MapPin className="mr-2" size={18} />
                LOCATION
              </h4>
              <div className="text-gray-300 text-sm">
                <p>
                  {" "}
                  Indore Bypass Rd, near Kushabhau Thackrey Road, opposite
                  Bharat Benz Showroom, Indore, Madhya Pradesh 452016
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-700/90 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-300 text-sm">
              © 2026 Domigo All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link
                to="/privacy-policy"
                className="text-gray-300 hover:text-domigo-pink text-sm transition-colors"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms-of-service"
                className="text-gray-300 hover:text-domigo-pink text-sm transition-colors"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
